<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/tools/product/index' }">抢购助手</el-breadcrumb-item>
      <el-breadcrumb-item>{{ form.id <= 0 ? '添加' : '编辑'}}抢购活动</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-form :model="form" ref="ruleForm" :rules="rules" label-width="160px">
          <el-form-item label="活动名称" prop="name">
            <el-col :span="12">
              <el-input size="small" v-model="form.name" placeholder="请输入活动名称"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="所属平台" prop="type">
            <el-col :span="12">
              <el-select
                size="small"
                v-model="form.type"
                placeholder="请选择所属平台"
                style="width: 100%;"
              >
                <el-option
                  v-for="(item, index) in platforms"
                  :key="index"
                  :label="item.name"
                  :value="item.platform"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>

          <el-form-item label="商品简称" prop="abbr_name">
            <el-col :span="12">
              <el-input size="small" v-model="form.abbr_name" placeholder="请输入商品简称, 用于搜索使用"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="商品全称" prop="full_name">
            <el-col :span="12">
              <el-input size="small" v-model="form.full_name" placeholder="请输入商品全称, 请尽量确保商品在首屏"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="商品价格" prop="price">
            <el-col :span="12">
              <el-input size="small" v-model="form.price" placeholder="请输入商品价格"></el-input>
            </el-col>
          </el-form-item>
          
          <el-form-item label="预约开始时间" prop="reserve_start">
            <el-col :span="12">
              <el-time-picker
                v-model="form.reserve_start"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                placeholder="请选择预约开始时间">
              </el-time-picker>
            </el-col>
          </el-form-item>

          <el-form-item label="预约结束时间" prop="reserve_end">
            <el-col :span="12">
              <el-time-picker
                v-model="form.reserve_end"
                value-format="HH:mm:ss"
                placeholder="请选择预约结束时间">
              </el-time-picker>
            </el-col>
          </el-form-item>

          <el-form-item label="开始抢购时间" prop="activity_time">
            <el-col :span="12">
              <el-time-picker
                v-model="form.activity_time"
                value-format="HH:mm:ss"
                placeholder="请选择开始抢购时间">
              </el-time-picker>
            </el-col>
          </el-form-item>

          <el-form-item label="持续时间" prop="duration_time">
            <el-col :span="12">
              <el-input size="small" v-model="form.duration_time" placeholder="请输入抢购活动持续时间"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        id: '',
        type: '',
        duration_time: '',
        reserve_start: '',
        reserve_end: '',
        abbr_name: '',
        name: '',
        full_name: '',
        activity_time: '',
        price: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 1, max: 255, message: '活动名称长度在1到255个字符', trigger: 'blur' }
        ],
        abbr_name: [
          { required: true, message: '请输入商品简称', trigger: 'blur' },
          { min: 1, max: 255, message: '商品简称在1到255个字符', trigger: 'blur' }
        ],
        full_name: [
          { required: true, message: '请输入商品全称', trigger: 'blur' },
          { min: 1, max: 255, message: '商品全称在1到255个字符', trigger: 'blur' }
        ],
      },

      platforms: []
    };
  },
  methods: {
    loadProduct() {
      var id = this.$route.query ? this.$route.query.id : 0;
      if(!id) {
        return 0
      }

      this.$ajax({
        url: "/tools/product/one?id=" + id,
        type:"GET",
      }).then(res => {
        this.form = res.data
      });
    },
    loadPlatforms() {
      this.$ajax({
        url: "/constant/platform",
        type:"GET",
      }).then(res => {
        this.platforms = res.data
      });
    },
    save() {
      let form = this.form;
      this.$refs.ruleForm.validate((valid) => {
        if(!valid) {
          return false;
        }

        // 开始处理loading.
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          type: 'POST',
          url: '/tools/product/save',
          data: form,
        }).then((res) => {
          loading.close()
          if(res.code != 200) {
            return this.$util.msg(res.msg, "error");
          }
          
          this.$util.msg(res.msg, "success");

          setTimeout(() => {
            this.$router.push({ path: "/tools/product/index" });
          });
        })
      });

      return false;
    }
  },
  mounted() {
    this.loadProduct()
    this.loadPlatforms()
  }
};
</script>
<style>
</style>